module.exports = __webpack_public_path__ + "img/sushi.5a6742b2.svg";